import ProjectCard from "../PageLayout/ProjectCard";
import InfoPopup from "../Utils/InfoPopup.jsx";
import ProjectButton from "../Utils/ProjectButton";
import { ProjectType } from "../Utils/ProjectType.ts";
import ProjectHeader from "./ProjectHeader";
import sharedStyles from "./shared.module.css" 


export default function Arthurlytics () {


    return (
        <ProjectCard projectName={'Arthurlytics'}>
            
            <ProjectHeader title={"ARTHURLYTICS"} subTitle={"DJAZE Project"} projectType={ProjectType.Code} subTitleInfo="A tech friend group where we share knowledge and build passion projects together." subTitleInfoLeft={true} />

            <p>
                Arthurlytics is a data analytics & visualization website tracking performance of browser games hosted across multiple sites!
            </p>

            <p>
                This project was created in collaboration with my friend and Data Engineer, Zaz, under the banner of <InfoPopup info={"A tech friend group where we share knowledge and build passion projects together."}><strong>DJAZE</strong></InfoPopup>.
            </p>

            <p>
                I developed the React frontend, which consumes data hosted on <strong>AWS S3</strong>. The data pipeline, built by Zaz, uses <strong>GitHub Actions</strong> for ingest and processing, and is queried via <strong>AWS Athena</strong>.
            </p>

            <div >
                <img src="/images/Arthurlytics.png" alt="Display of Arthurlytics" className={sharedStyles.image} />
            </div>

            <br />

            <div className={sharedStyles.links}>
                <ProjectButton link={"https://d2js5vqrfj7red.cloudfront.net/"} name={"Check it out"} />

                <ProjectButton name={"Code"} disabled={true} reason="We’ve decided to keep this project private for now, but I’d be happy to chat about it on LinkedIn if you’re curious!" />
                
            </div>
        </ProjectCard>
    )
}